<template>
  <div class="container">
    <h1>Privacy Policy for Stud + Metal Scanner</h1>
    <p><strong>Effective Date: January 2026</strong></p>
    <p>Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information.</p>

    <h2>No Data Collection</h2>
    <p>We do not collect, store, or transmit any personal information. All data from the magnetometer sensor is processed locally on your device and is not saved.</p>

    <h2>App Functionality</h2>
    <p>The app uses your device's magnetometer to detect metal and magnetic fields. This data is used only for the app's core functionality and is not used for any other purpose.</p>

    <h2>Advertising</h2>
    <p>Our app does not contain any third-party advertising. We do not share any data with advertising companies.</p>

    <h2>Contact Us</h2>
    <p>If you have any questions, please email us at: <a href="mailto:care@thewishboard.com">care@thewishboard.com</a></p>
  </div>
</template>

<script>
export default {
  name: 'StudFinderPrivacy'
};
</script>

<style scoped>
.container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
h1, h2 {
  color: #000;
}
a {
  color: #007aff;
}
</style>
